module.exports = __webpack_public_path__ + "img/keep_it_up.09ef41c0.svg";